import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { useData } from '../../context/DataContext';

const Footer = () => {
  const { siteSettings } = useData();

  const whatsappUrl = `https://wa.me/${siteSettings?.whatsappNumber || '905546500984'}?text=${encodeURIComponent('Merhaba Taşdemir İnşaat, proje hakkında bilgi almak istiyorum.')}`;

  return (
    <footer className="bg-anthracite-dark border-t border-gold/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_ca4d188f-c124-42c2-8023-1edcea1f585d/artifacts/jdaomiy2_tas%E2%95%A0%C2%BAdemir-ins%E2%95%A0%C2%BAaat-logo-02.jpg"
                alt="Taşdemir İnşaat"
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              {siteSettings?.aboutShort}
            </p>
            <div className="flex items-center space-x-4 mt-6">
              <a
                href={siteSettings?.instagram || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-anthracite rounded-full text-gray-400 hover:text-gold hover:bg-gold/10 transition-all duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-gold font-semibold text-sm uppercase tracking-wider mb-6">
              Hızlı Bağlantılar
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-gold transition-colors duration-300 text-sm"
                >
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link
                  to="/projeler"
                  className="text-gray-400 hover:text-gold transition-colors duration-300 text-sm"
                >
                  Projeler
                </Link>
              </li>
              <li>
                <Link
                  to="/hakkimizda"
                  className="text-gray-400 hover:text-gold transition-colors duration-300 text-sm"
                >
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link
                  to="/iletisim"
                  className="text-gray-400 hover:text-gold transition-colors duration-300 text-sm"
                >
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-gold font-semibold text-sm uppercase tracking-wider mb-6">
              İletişim
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${siteSettings?.phone1?.replace(/\s/g, '')}`}
                  className="flex items-start space-x-3 text-gray-400 hover:text-gold transition-colors duration-300 group"
                >
                  <Phone className="w-4 h-4 mt-0.5 group-hover:text-gold" />
                  <span className="text-sm">{siteSettings?.phone1}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${siteSettings?.phone2?.replace(/\s/g, '')}`}
                  className="flex items-start space-x-3 text-gray-400 hover:text-gold transition-colors duration-300 group"
                >
                  <Phone className="w-4 h-4 mt-0.5 group-hover:text-gold" />
                  <span className="text-sm">{siteSettings?.phone2}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${siteSettings?.email}`}
                  className="flex items-start space-x-3 text-gray-400 hover:text-gold transition-colors duration-300 group"
                >
                  <Mail className="w-4 h-4 mt-0.5 group-hover:text-gold" />
                  <span className="text-sm">{siteSettings?.email}</span>
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{siteSettings?.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gold/10 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Taşdemir İnşaat. Tüm hakları saklıdır.
          </p>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 md:mt-0 px-6 py-2.5 bg-gold/10 text-gold font-medium text-sm rounded hover:bg-gold hover:text-anthracite transition-all duration-300"
          >
            WhatsApp'tan İletişime Geç
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;